import React from 'react';
import '../BlogPage/Styles.css';
import useTitle from '../../useTitle';
import ContactSection from '../ContactSection/Index';
import { useBlog } from '../../context/BlogContext';
import { urlFor } from '../../sanityProject/urlFor';
import { PortableText } from '@portabletext/react';

const BlogPagina = () => {
  useTitle("Blog");

  const { posts } = useBlog();

  return (
    <>
      <div className='blogPageContainer'>

        <div className='blogTitleContainer'>
          <h1 className='blogTitle'>
            Yoga, mindfulness en lifestyle in één inspirerende blog.
          </h1>
        </div>

        <div className='blogPostsHomeContainer'>

          {posts.map((post) => (
            <a href={`/blog/${post.slug.current}`} key={post._id}>
              <div className='blogPost'>

                {/* HEADER IMAGE */}
                <div className='photoOfBlogPost'>
                  {post.headerImage && (
                    <img
                      src={urlFor(post.headerImage).url()}
                      className='photoBlogPost'
                      alt={post.title}
                    />
                  )}
                </div>

                {/* AUTHOR + DATE */}
                <div className='authorAndDateSectionBlogPage'>
                  <p className='dateOfBlogPagePost'>
                    {post.date
                      ? new Date(post.date).toLocaleDateString('nl-BE')
                      : ''}
                  </p>

                  <div className='authorOfBlogPostBlogPage'>
                    {post.author?.image && (
                      <img
                        src={urlFor(post.author.image).url()}
                        className='authorImagePhotoBlogPage'
                        alt={post.author?.name}
                      />
                    )}

                    <p className='authorNameBlogPage'>
                      {post.author?.name}
                    </p>
                  </div>
                </div>

                {/* TITLE */}
                <div className='titleOfBlogPost'>
                  <h2>{post.title}</h2>
                </div>

                {/* SUMMARY */}
                <div className='summaryOfBlogPost'>
                  <PortableText value={post.summary} />
                </div>

                {/* BUTTON */}
                <div className='readBlogPostSection'>
                  <span className='readBlogPostButton'>
                    Meer lezen
                  </span>
                </div>

              </div>
            </a>
          ))}

        </div>

      </div>

      <ContactSection />
    </>
  );
};

export default BlogPagina;